import React from "react";
import { reportClientError } from "../services/errorReporter";

interface State {
    hasError: boolean;
}

/** Evita la pantalla en blanco cuando un componente falla al renderizar y reporta el error. */
export default class ErrorBoundary extends React.Component<{ children: React.ReactNode }, State> {
    state: State = { hasError: false };

    static getDerivedStateFromError(): State {
        return { hasError: true };
    }

    componentDidCatch(error: Error, info: React.ErrorInfo) {
        reportClientError("ErrorBoundary", {
            message: error.message,
            stack: `${error.stack ?? ""}\n${info.componentStack ?? ""}`,
        });
    }

    render() {
        if (!this.state.hasError) return this.props.children;
        return (
            <div style={{ padding: 32, textAlign: "center" }}>
                <h3>Ocurrió un error inesperado</h3>
                <p>El problema fue reportado. Recargue la página para continuar.</p>
                <button onClick={() => window.location.reload()}>Recargar</button>
            </div>
        );
    }
}
